module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAPCAYAAAACsSQRAAAABGdBTUEAALGPC/xhBQAAATZJREFUOBGdkr1KA0EUhc8sS0CQkEIEC1OKiYX4Br6CjVjaWWghxtJGsBJ/GjXmFfI2Fq5ROy0E7VQQwmzGe4bNsJmdXYMDy5259ztn7swOUDGMgUqucMlYgSGqKg5usGWAfcYqrnSH1z5mPt8xEHFTvpf6PJYXN/ETMivt5OsDB5kBdc1sHfIInzXpYcFoPMFg1qkUvlWMpfYO3lwum4Q70TiZMCBMQ+YDo2By38WaCLYtq3C8sifdSrRrydu6Z1QwUSku5I8U8tQxz7rnMQknXWwIuO5D+TXr5PI5t6Ppo2ZGOM0Xy+bkyI/r7p08XKMzMjgbF/6KkcJhaxfn5Gwnjz3MicFRQehfbA4gT50zSbW9/UaOmWbayHRQz7doDzXuRBVPo/QYXYuxGg1Te67/GNAvpv4XFplebELiMhgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/utils/assets/images/icon-alert-avatar.png
// module id = 268
// module chunks = 0